import React from "react";
import { messages } from "../../../localization/messages";

const ErrorBoundary = () => (
  <h1
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}
  >
    {messages.error_default}
  </h1>
);

export default ErrorBoundary;
